import React from 'react';
import { Stack } from 'expo-router';

import { useGiftCardsTabStackOptions } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function GiftCardsTabLayout() {
  const options = useGiftCardsTabStackOptions();

  return (
    <Stack screenOptions={options.Stack} initialRouteName="index">
      <Stack.Screen name="checkout/[assetId]/index" options={options.Checkout} />
      <Stack.Screen name="confirmation/[orderId]/index" options={options.Confirmation} />
      <Stack.Screen name="index" options={options.Home} />
      <Stack.Screen name="redeem/[giftCardId]/index" options={options.Redeem} />
    </Stack>
  );
}
